module.exports = __webpack_public_path__ + "img/xmi.f5e7e7f5.png";